<template>
    <v-container fluid fill-height>
        <v-card
            class="mx-auto justify-center"
            flat
        >
            <v-row justify="center" align="center">
                <v-col
                    align-self="center"
                    cols="auto"
                    justify-center
                >
                    <v-avatar 
                        class="justify-center" 
                        size=164
                        align-self="center"
                        round
                    >
                        <v-img src="rr-profile.jpg"></v-img>
                    </v-avatar>
                </v-col>
            </v-row>
            <v-row justify="center" align="center">
                <v-col
                    cols="12"
                    md="6"
                >
                    <v-card-title class="justify-center" v-text=item.headline></v-card-title>
                    <v-card-subtitle class="text-center" v-text=item.one_line_intro></v-card-subtitle>
                    <v-card-text class="text-center">
                        <div v-text=item.intro_0></div>
                        <!-- <div v-text=item.intro_1></div> -->
                    </v-card-text>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'Lander',
    data: () => ({
        item: {
            headline: "Hi, I'm Ryan!",
            one_line_intro: "Junior researcher in Mathematical Analysis ",
            intro_0: "I obtained my MS from CSULB, and my BS from UCLA, both in Pure Math \
            Passionate about learning, researching, and teaching. \
            My other hobbies include literature, philosophy, and gaming."
        }
    })
};
</script>

<style lang="css" scoped>
.v-card {
    padding-top: 2%;
}
</style>

